<template>
  <div class="card-status-dialog">
    <el-dialog
      title="Update Card Status"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : ''"
      :before-close="handleClose"
      top="5vh"
    >
      <div class="status-area">
        <el-tag effect="dark" type="warning" class="margin-right">{{ statusFrom }}</el-tag> To <el-tag class="margin-left" effect="dark" :type="statusTo === 'closed' ? 'danger': 'success'">{{ statusTo }}</el-tag>
      </div>
      
      <div class="status-select" v-if="statusTo === 'closed'">
        <h3>You are above to closing the card. Please confirm action</h3>      
        <el-select v-model="reason" placeholder="Select">
          <el-option label="Card stolen" value="card-stolen"></el-option>
          <el-option label="Card destroyed" value="card-destroyed"></el-option>
        </el-select>
      </div>


      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">Cancel</el-button>
        <el-button type="primary" :loading="submiting" @click="submitStatus()">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cardStatus } from "@/api/card";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    username(){
      return this.$store.state.user.fullname;
    }
  },
  data(){
    return {
      dialogShow: false,
      statusFrom:"",
      statusTo:"",
      cardID: "",
      reason: "card-stolen",
      submiting: false
    }
  },
  methods:{

    openDialog(statusFrom, statusTo, cardID){
      this.cardID = cardID;
      this.statusFrom = statusFrom;
      this.statusTo = statusTo;
      this.dialogShow = true
    },

    submitStatus(){
      this.submiting = true
      let data = {
        "user": this.username,
        "status": this.statusTo,
        "reason" : this.statusTo === 'closed' ? this.reason : ""
      }

      cardStatus(this.cardID, data).then(({result}) =>{
        this.submiting = false
        if(result){
          this.dialogShow = false
          this.$notify({
            title: 'Success',
            message: `Update Card Status successfully`,
            type: 'success',
            duration: 2000
          });
          this.$emit('submited')
        }
      })
    },
    handleClose(){}
  }
}
</script>

<style lang="scss">
.card-status-dialog{
  .status-area{
    text-align: center;

    .el-tag{
      font-size: 20px;
      padding: 12px 18px;
      height: auto;
      text-transform: uppercase; 
    }

    .margin-right{
      margin-right: 15px;
    }
    .margin-left{
      margin-left: 15px;
    }
  }

  .status-select{
    text-align: center;
    margin-top: 20px;

    .el-select{
      width: 280px;
    }
  }
}
</style>